/* globals confirm, console, document, module, navigator, require, window */
/* jshint esversion:6, globalstrict:true */
'use strict';

const jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    //
    user = require('../models/user'),
    FiltersList = require('./filtersList'),
    //
    AddressAutocomplete = require('../utilities/addressAutocomplete'),
    configuration = require('../utilities/configuration'),
    formProcessor = require('../utilities/formProcessor').processor,
    helpers = require('../utilities/handlebars').helpers,
    templates = require('../utilities/handlebars').templates;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'wizard',
        role: 'document'
    },
    events: {
        'click @ui.close': 'onClickClose',
        'click button': 'onClickButton'
        // 'click img[name=geolocate]':  'onClickGeolocate'
    },
    groupIndex: 0,
    lastCount: -1,
    regions: {
        filtersList: 'div[name=filtersList]'
    },
    section: 'form',
    tagName: 'div',
    template: templates.wizard,
    templateContext: function () {
        return {
            isGuest: !user.hasCapability('enrollee')
        };
    },
    ui: {
        close:           'button[data-action=close]',
        congratulations: 'div[name=congratulations]',
        form:            'div[name=form]',
        // geolocate:       'img[name=geolocate]',
        oops:            'div[name=oops]',
        latitude:        'input[name=latitude]',
        location:        'input[name=location]',
        locationComment: 'small[name=locationComment]',
        longitude:       'input[name=longitude]',
        next:            'button[data-action=next]',
        previous:        'button[data-action=previous]',
        programCount:    'span[name=programCount]',
        results:         'div[name=results]',
        searching:       'span[name=searching]',
        start:           'span[name=start]',
        submit:          'button[data-action=submit]',
        sorry:           'div[name=sorry]'
    },
    //
    applyFilters: function () {
        const serializedFilters = this.ui.form.find('form').serializeArray(),
            processedFilters = formProcessor(serializedFilters, 'wizard');
        this.getChildView('filtersList').updateFilters(serializedFilters);
        processedFilters.invalidateCache = new Date().getTime();
        // for now, recreate the distance structure created by the filter set mechanism here because this will be fed to the filter set mechanism...
        if (processedFilters.miles && processedFilters.location) {
            processedFilters.distance = {
                miles: processedFilters.miles,
                latitude: processedFilters.latitude,
                longitude: processedFilters.longitude,
                location: processedFilters.location
            };
        }
        delete processedFilters.miles;
        delete processedFilters.latitude;
        delete processedFilters.longitude;
        delete processedFilters.location;
        this.trigger('apply:wizardFilters', processedFilters);
    },
    close: function () {
        // jQuery('#screenReaderAnnouncementsAssertive').text('Dialog closed');
        // jQuery(document).off('keyup', _.bind(this.onKeyup, this));
        // jQuery(document).off('keydown', _.bind(this.onKeydown, this));
        this.ui.close.trigger('click');
    },
    count: function (count) {
        this.lastCount = count;
        this.statify('count');
    },
    initialize: function () {
        this.listenTo(this.collection, 'reset', _.bind(function () {
            this.ui.results.toggleClass('d-none', this.groupIndex === 0);
            this.count(this.collection.length);
        }, this));
        this.modal = jQuery('#modal');
        this.keyupHandler = _.bind(this.onKeyup, this);
        this.keydownHandler = _.bind(this.onKeydown, this);
    },
    onAttach: function () {
        this.$el.append('<div class="iframe-marker" data-iframe-height="1"></div>');
        this.modal.html(this.$el);
        this.delegateEvents();  // rebind event handlers
        this.bindUIElements();
        this.modal.modal({backdrop: 'static', focus: false, keyboard: false});
        this.$el.find('button')[0].focus();
    },
    onClickButton: function (event) {
        let bubble = false;
        switch (event.currentTarget.dataset.action) {
            case 'changeAnswers':
                this.section = 'form';
                this.groupIndex = 0;
                this.resetForm();
                this.trigger('apply:wizardFilters', []);
                this.statify();
                break;
            case 'geolocate':
                this.onClickGeolocate();
                break;
            case 'next':
                this.groupIndex++;
                this.statify('previousNext');
                break;
            case 'previous':
                this.groupIndex--;
                this.statify('previousNext');
                break;
            case 'closeWizard':
                this.ui.close.trigger('click');
                break;
            case 'jumpToHb101':
                this.ui.close.trigger('click');
                this.trigger('jump:hb101');
                break;
            default:
                bubble = true;
                break;
        }
        return bubble;
    },
    onClickClose: function () {
        jQuery('#screenReaderAnnouncementsAssertive').text('Dialog closed');
        // jQuery(document).off('keyup', _.bind(this.onKeyup, this));
        // jQuery(document).off('keydown', _.bind(this.onKeydown, this));
        jQuery(document).off('keyup', this.keyupHandler);
        jQuery(document).off('keydown', this.keydownHandler);
        jQuery('.pac-container').slice(1).remove();
        this.trigger('wizard:close');
    },
    onClickGeolocate: function () {
        const defaultLatitude = configuration.geolocations[configuration.geolocation].latitude,
            defaultLongitude = configuration.geolocations[configuration.geolocation].longitude;
        if (configuration.useGeolocation && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(_.bind(function (position) {
                const latitude = position.coords.latitude ? position.coords.latitude : defaultLatitude,
                    longitude  = position.coords.longitude ? position.coords.longitude : defaultLongitude;
                this.resolveLocation(latitude + ', ' + longitude);
            }, this));
        } else {
            // browser doesn't support geolocation
            this.resolveLocation(defaultLatitude + ', ' + defaultLongitude);
        }
        return false;
    },
    onKeydown: function (event) {
        let tabPosition;
        if (event.which === 9) {
            tabPosition = document.activeElement.dataset ? document.activeElement.dataset.tabPosition : null;
            switch (tabPosition) {
                case 'first':
                    if (event.shiftKey) {
                        this.$el.find('[data-tab-position=last]').focus();
                        event.preventDefault();
                    }
                    break;
                case 'last':
                    if (!event.shiftKey) {
                        this.$el.find('[data-tab-position=first]').focus();
                        event.preventDefault();
                    }
                    break;
                default:
                    break;
            }
        }
    },
    onKeyup: function (event) {
        let selector,
            element;
        switch (event.which) {
            // case 38:
            //     console.log('up...');
            //     break;
            // case 40:
            //     console.log('down...');
            //     break;
            case 27: // escape
                // console.log('wizard.keyup - escape');
                selector = '[data-action=close]';
                break;
            default:
                break;
        }
        if (selector) {
            element = this.$el.find(selector);
            if (!element.attr('disabled')) {
                element.trigger('click');
            }
        }
    },
    onRender: function () {
        // console.log('@acavan: wizard.onRender - this.options.filters', this.options.filters);
        let input = this.$el.find('input[name=location]')[0];
        this.addressAutocomplete = new AddressAutocomplete(input, _.bind(this.updateLocation, this));
        this.groups = this.$el.find('form div[data-group=true]');
        this.showChildView('filtersList', new FiltersList({collection: this.options.filters, wizard: true}));
        this.resetForm(true);

        // Hide "minor youth" as a filter.
        jQuery('[id*="householdTypeIds_4"]', this.$el).parent().addClass('d-none');

        // jQuery(document).on('keyup', _.bind(this.onKeyup, this));
        // jQuery(document).on('keydown', _.bind(this.onKeydown, this));
        jQuery(document).on('keyup', this.keyupHandler);
        jQuery(document).on('keydown', this.keydownHandler);
        this.ui.location.focus(_.bind(function (event) {
            this.priorAddressAutocomplete = this.ui.location.val();
        }, this));
        this.ui.location.blur(_.bind(function (event) {
            // remove any text on blur and, if an autocomplete has occurred, display the formatted address above
            if (this.ui.location.val() !== this.priorAddressAutocomplete) {
                this.ui.location.val('');
            }
        }, this));
        return this;
    },
    resetForm: function (retainDistance) {
        // used to clear all the answers but now just disables controls on each page
        let filterSet;
        this.$el.find('input:text').val('');
        this.$el.find('input:radio').each(function (index, radio) {
            radio.disabled = true;
        });
        this.$el.find('input:checkbox').each(function (index, checkbox) {
            checkbox.disabled = true;
        });
        this.$el.find('select').each(function (index, select) {
            select.disabled = true;
        });
        filterSet = this.options.filters.getFilterSet();
        if (filterSet.distance) { // at some point share common bits from programsSidebarFilter.onApplyFilterSet...
            _.each(filterSet.distance, _.bind(function (value, key) {
                let selector;
                switch (key) {
                    case 'miles':
                        this.$el.find('select[name=miles]').val(value);
                        break;
                    default:
                        this.$el.find('input[name=' + key + ']').val(value);
                        break;
                }
            }, this));
        }
        this.applyFilters();
    },
    resolveLocation: function (location) {
        this.addressAutocomplete.resolveLocation(location, _.bind(function (error, location) { // jscs:disable disallowDanglingUnderscores
            if (!this._isDestroyed) {
                this.updateLocation(location);// jscs:enable disallowDanglingUnderscores
            }
        }, this));
    },
    statify: function (via) {
        const serializedFilters = this.ui.form.find('form').serializeArray(),
            processedFilters = formProcessor(serializedFilters, 'wizard');
        this.ui.previous.attr('disabled', via === 'previousNext');
        this.ui.next.attr('disabled', via === 'previousNext');
        if (processedFilters.wantsOurServices === false) {
            this.section = 'oops';
        }
        if (this.section !== 'oops') {
            this.ui.next.attr('disabled', this.groupIndex >= this.groups.length || via === 'previousNext');
            this.ui.previous.attr('disabled', this.groupIndex < 1 || via === 'previousNext');
        }
        if (via === 'count') {
            if (this.lastCount === 0) {
                this.section = 'sorry';
            }
            this.ui.searching.toggleClass('hidden', true);
            this.ui.programCount.toggleClass('hidden', this.groupIndex === 0);
            this.ui.programCount.text(helpers.l10n(this.lastCount === 1 ? 'foundProgramSingular' : 'foundProgramsPlural').replace('_COUNT_', this.lastCount));
            this.ui.programCount.toggleClass('lowAvailability', this.lastCount < 6);
            if (this.section === 'penultimate') {
                this.section = this.lastCount ? 'congratulations' : 'sorry';
            }
        }
        if (this.section === 'form') {
            if (via !== 'count') {
                this.ui.programCount.toggleClass('hidden', true);
                this.ui.searching.toggleClass('hidden', false);
                this.applyFilters();
            } else {
                this.getChildView('filtersList').updateFilters(serializedFilters);
                _.each(this.groups, _.bind(function (group, index) {
                    jQuery(group).toggleClass('hidden', index !== this.groupIndex);
                    jQuery('input', group).prop('disabled', index > this.groupIndex);
                    jQuery('select', group).prop('disabled', index > this.groupIndex);
                }, this));
            }
            if (this.groupIndex >= this.groups.length) {
                this.section = 'penultimate';
            }
        }
        _.each(['form', 'oops', 'congratulations', 'sorry'], _.bind(function (section) {
            this.ui[section].toggleClass('hidden', this.section !== section);
        }, this));
        this.$el.find('button')[0].focus();
    },
    updateLocation: function (location) {
        if (!location.error) {
            this.ui.locationComment.text('');
            this.ui.latitude.val(location.latitude || '');
            this.ui.longitude.val(location.longitude || '');
            this.priorAddressAutocomplete = location.formattedAddress;
            this.ui.location.val(location.formattedAddress).blur();
            if (location.latitude && location.longitude) {
                this.trigger('latitudeLongitude:updated', {latitude: location.latitude, longitude: location.longitude, source: 'programsSidebarFilter.updateLocation'});
            }
        } else {
            this.ui.locationComment.text(location.error);
        }
    }
});
